module.exports = __webpack_public_path__ + "img/cpzx_mobile_card.f75a6dd0.png";